import { FamilyHome } from "../FamilyHome.jsx";

function PhysFamilySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Physics as the rules, not the formulas
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Physics is the science of what is allowed and what is not — what
        combinations of particles can form, what trajectories objects can
        follow, what energy levels electrons can occupy. The formulas describe
        the rules, but the rules came first and they are what matters.
        NerdPhys games hand you the rules as game mechanics and let you build
        within them: forge particles that obey color charge, aim trajectories
        that obey gravity. The formula reads easier afterward because you
        already know what it describes.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What's here
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        QuarkForge — build real hadrons from quarks. The strong-force color-
        neutrality rule is enforced as a game mechanic. Discover the proton,
        neutron, pions, kaons, J/ψ, Upsilon, all the way through to the
        doubly-charmed Xi (LHCb 2017). The hadron zoo, walked one particle
        at a time, with the Standard Model's rules as the gameplay.
      </p>
    </>
  );
}

export default function PhysHome() {
  return <FamilyHome familyId="phys" seoContent={<PhysFamilySeo />} />;
}
